import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { TRAINING_OPTIONS } from "./catalog";

export default function TrainingOptions() {
  const scrollTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  const handle = (o) => {
    if (o.href) window.location.href = o.href;
    else scrollTo(o.target);
  };

  return (
    <section
      id="training-options"
      data-testid="training-options-section"
      className="py-16 md:py-36 bg-black border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-3xl mb-14"
        >
          <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
            Ways To Train
          </p>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            Training Options
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TRAINING_OPTIONS.map((o, i) => (
            <motion.div
              key={o.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.08, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`option-card-${i}`}
              className={`group flex flex-col p-8 border transition-all duration-500 hover:-translate-y-2 ${
                o.featured ? "bg-white text-black border-white" : "bg-[#0a0a0a] border-white/10 hover:border-white/30"
              }`}
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="font-display font-bold uppercase tracking-tight text-2xl leading-none">
                  {o.name}
                </h3>
                {o.featured && (
                  <span className="font-mono-accent text-[9px] tracking-[0.2em] uppercase bg-black text-white px-2 py-1">
                    Popular
                  </span>
                )}
              </div>
              <p className={`font-mono-accent text-sm tracking-[0.1em] uppercase mb-6 ${o.featured ? "text-black/60" : "text-white/45"}`}>
                {o.price}
              </p>
              <ul className={`space-y-3 text-sm flex-1 ${o.featured ? "text-black/75" : "text-white/60"}`}>
                {o.includes.map((inc) => (
                  <li key={inc} className="flex items-start gap-2">
                    <Check size={16} className={`mt-0.5 shrink-0 ${o.featured ? "text-black" : "text-white/70"}`} />
                    {inc}
                  </li>
                ))}
              </ul>
              <button
                data-testid={`option-cta-${i}`}
                onClick={() => handle(o)}
                className={`mt-8 uppercase tracking-[0.15em] font-bold text-xs px-5 py-4 transition-colors duration-300 ${
                  o.featured ? "bg-black text-white hover:bg-black/80" : "border border-white/20 text-white hover:bg-white hover:text-black"
                }`}
              >
                {o.cta}
              </button>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 font-mono-accent text-[11px] tracking-[0.15em] uppercase text-white/30">
          Pricing shown on request — final rates confirmed after your free evaluation.
        </p>
      </div>
    </section>
  );
}
